import { SecretValueInput, type SecretValueInputProps } from "../../../../../shared/frontend/forms/SecretInput";
import { useI18n } from "../app/i18n/useI18n";

export type SecretInputProps = Omit<SecretValueInputProps, "showText" | "hideText">;

/** Compatibility adapter for existing member credential fields; masking and browser handling are shared. */
export function SecretInput(props: SecretInputProps) {
  const { text } = useI18n();
  return <SecretValueInput {...props} showText={text("Show password")} hideText={text("Hide password")} />;
}
